import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { map, memoize } from 'lodash';

import Modal from 'components/Modal';
import RadioList from 'components/Modal/RadioList';
import i18n from 'i18n';

const ErrorText = styled.div`
  margin-top: 20px;
  color: red;
  text-align: center;
`;

export default class ReportingModal extends Component {
  static propTypes = {
    onClose: PropTypes.func.isRequired,
    onReport: PropTypes.func.isRequired
  };

  state = {
    selectedType: null,
    error: null
  };

  typesToItems = memoize((types) =>
    map(types, (value, key) => ({
      value: key,
      title: value()
    }))
  );

  changeType = (selectedType) => {
    this.setState({ selectedType });
  };

  onReport = () => {
    const { selectedType } = this.state;
    if (selectedType) {
      this.props.onReport(selectedType);
    } else {
      this.setState({ error: i18n('component.ReportModal.Error')() });
    }
  };

  contentAbove() {
    const { error } = this.state;
    if (!error) {
      return;
    }

    return <ErrorText>{error}</ErrorText>;
  }

  contentCenter() {
    const items = this.typesToItems(i18n('component.ReportModal.ReportTypes'));
    return (
      <RadioList
        items={items}
        onChange={this.changeType}
        selectedValue={this.state.selectedType}
      />
    );
  }

  render() {
    const { onClose } = this.props;
    return (
      <Modal
        id="ReportModal"
        buttons={[
          {
            text: i18n('component.ReportModal.Cancel')(),
            onClick: onClose
          },
          {
            highlight: true,
            text: i18n('component.ReportModal.Report')(),
            onClick: this.onReport
          }
        ]}
        contentAbove={this.contentAbove()}
        contentCenter={this.contentCenter()}
        title={i18n('component.ReportModal.Title')()}
        onClose={onClose}
      />
    );
  }
}
